import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, Optional, ViewChild } from '@angular/core';
import { ControlContainer, FormsModule, NgControl, NgForm } from '@angular/forms';
import { Logger } from '@df/core/service/logger';
import { FormFieldModel } from '../../../field-abstract/form-field.model';
import { RadioGroupComponent } from '../radio-group.component';
import { RadioComponent } from '../../radio.component';

@Component({
    standalone: true,
    imports: [FormsModule, RadioComponent],
    selector: 'radio-group-item',
    templateUrl: 'radio-group-item.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class RadioGroupItemComponent<T> implements OnInit, OnDestroy, OnChanges {
    @Input()
    get model(): T | undefined {
        return this.radioGroup.model;
    }
    set model(model: T | undefined) {
        this.radioGroup.model = model;
    }

    get name() {
        return this.radioGroup.name;
    }

    get required() {
        return this.radioGroup.required;
    }

    @Input()
    value?: T;

    @Input()
    disabled = false;

    @ViewChild(NgControl, { static: true })
    ngControl?: NgControl;

    @ViewChild(NgControl, { static: true, read: ElementRef })
    inputRef?: ElementRef;

    /**
     * Cleanup method to unregister contrlls
     */
    private unregisterModel: (() => void) | undefined;

    onModelChange() {
        this.radioGroup.onModelChange();
    }

    constructor(
        private radioGroup: RadioGroupComponent<T>,
        private logger: Logger,
        @Optional() private formFieldModel?: FormFieldModel
    ) {}

    ngOnInit() {
        if (this.value === undefined) {
            this.logger.error('Radio group item is missing the value', this);
        }
        if (this.ngControl && this.inputRef) {
            this.unregisterModel = this.formFieldModel?.register({ ngControl: this.ngControl, inputRef: this.inputRef });
        } else {
            this.logger.error('Cannot bind inputRef and ngControl', this);
        }
    }

    ngOnDestroy(): void {
        if (this.unregisterModel) {
            this.unregisterModel();
        }
    }

    ngOnChanges(changes) {
        if (changes.disabled) {
            this.formFieldModel?.notifyParamsChange();
        }
    }
}
